import React, { useMemo } from 'react';

import CartProductItem from './CartProduct';

import cartProductsModule from 'domains/cart_products';

import type { CartProduct, CartProductMaybeThumb } from 'domains/cart_products';

export type CartProductListProps = {
  cartProducts: CartProduct[];
  display?: 'full' | 'minimal';
  onShowImageGallery?: (show: boolean, index: number) => void;
  changeCartProductQuantity?: (id: number, quantity: number) => void;
  onDelete?: (id: number) => void;
  onEdit?: (product: CartProductMaybeThumb) => void;
};

function CartProductList({
  cartProducts,
  display = 'full',
  onDelete = () => {},
  onEdit = () => {},
  changeCartProductQuantity = () => {},
  onShowImageGallery = () => {},
}: CartProductListProps) {
  const cartProductsToRender = useMemo(
    () => cartProducts.filter(cartProductsModule.utils.hasData),
    [cartProducts]
  );

  return (
    <div className="cart_product_list">
      {cartProductsToRender.map((cartProduct, i) => {
        return (
          <CartProductItem
            key={cartProduct.id}
            allowEdit={display === 'full'}
            index={i}
            product={cartProduct}
            changeCartProductQuantity={changeCartProductQuantity}
            onDelete={onDelete}
            onShowImageGallery={onShowImageGallery}
            onEdit={onEdit}
          />
        );
      })}
    </div>
  );
}

export default CartProductList;
